<app-alert *ngIf="helperService.showAlert" [type]=helperService.typeAlert [Message]=helperService.messageAlert></app-alert>
<div class="Spinner" *ngIf="isLoading"><mat-spinner></mat-spinner></div>
<section
  class="section-reservation-hour"
  [formGroup]="formValidation"
  [ngClass]="{ isLoading: isLoading }"
>
  <div class="reservation">
    <app-my-reservation
      [tip_service]="ToSName"
      [kilometraje]="formValidation.value.kilometraje"
      [taller]="workShopName"
      [asesor]="advisorName"
      [date]="date"
      [time]="time"
      [cityName]="cityName"
      [LanguageForCountry]="recievedLanguageForCountry"
    ></app-my-reservation>
  </div>
  <div class="content-reservation-hour">
    <mat-stepper class="choose-service">
      <!-- <mat-step
        class="item-step-service step-1"
        [stepControl]="formValidation"
        completed="false"
      > -->
      <mat-step [stepControl]="firstFormGroup" >
        <form [formGroup]="formValidation">
          <ng-template matStepLabel>{{"SelectYourService" |translate}}</ng-template>

          <div class="grid-container-service">
            <div class="form-input-select">
              <p>{{"TypeOfService" |translate}}  &nbsp;<i *ngIf="TermAndConditiosMode === 'Derco'"
                class="bi bi-exclamation-circle"
                [id]="'exclamation'"
                (mouseover)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', true)"
                (mouseout)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', false)"
                matTooltip={{tooltip}}
                matTooltipPosition="above"
               
              ></i></p>
              <mat-form-field appearance="outline">
                <mat-label>{{"Select" |translate}}</mat-label>

                <mat-select formControlName="tip_service">
                  <mat-option
                    *ngFor="let typeOfService of typesOfservice"
                    [value]="typeOfService.serviceId"
                    (click)="onChangeTypeOfService(typeOfService.serviceId)"
                  >
                    {{ typeOfService.serviceName  | translate}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  tip_serviceControl?.invalid &&
                  (tip_serviceControl?.touched || tip_serviceControl?.dirty)
                "
              >
                <p class="error-ms">{{"ObligatoryField" |translate}}</p>
              </div>
            </div>
            <div class="form-input-select">
              <p>{{"Mileage" |translate}}<i *ngIf="TermAndConditiosMode === 'Chile'"
                class="bi bi-exclamation-circle"
                [id]="'exclamation'"
                (mouseover)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', true)"
                (mouseout)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', false)"
                matTooltip={{disclaimer}}
                matTooltipPosition="above"
               
              ></i></p>
              <mat-form-field appearance="outline">
                <mat-label> {{"Mileage" |translate}} </mat-label>
                <input matInput formControlName="kilometraje"   oninput="value = value.replace(/[^0-9]/g, '')" maxlength="6"/>
              </mat-form-field>
              <div
                *ngIf="
                  kilometrajeControl?.invalid &&
                  (kilometrajeControl?.touched || kilometrajeControl?.dirty)
                "
              >
                <p
                  class="error-ms"
                  *ngIf="kilometrajeControl.errors?.['required']"
                >
                  {{"ObligatoryField" |translate}}
                </p>
                <p
                  class="error-ms"
                  *ngIf="kilometrajeControl.errors?.['pattern']"
                >
                  {{"ObligatoryNumbers" |translate}}
                </p>
              </div>
            </div>
          </div>

          <!---------------------Espacio Calendario---------------------->
          <app-calendar-web-hour
            Indexbrand="{{ indexbrand }}"
            (timeChanged)="timeValue($event)"
            (dateChanged)="dateValue($event)"
            [timeListButtons]="timeButtons"
            [dateFilter]="DateFilter"
            [LanguageForCountry]="recievedLanguageForCountry"
          ></app-calendar-web-hour>
          <!---------------------End Espacio Calendario--------------------->
          <!--<pre> {{ formValidation.value | json }}</pre>-->

          <h3 class="input-title-blue">{{"ChooseWorkshopAndAdvisor" |translate}}</h3>
          <div class="grid-container-service">
            <div class="form-input-select">
              <p>{{"Workshop" |translate}}  &nbsp;<i *ngIf="TermAndConditiosMode === 'Derco'"
                class="bi bi-exclamation-circle"
                [id]="'exclamation'"
                (mouseover)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', true)"
                (mouseout)="onIconMouseHoverAndOut('exclamation', 'bi-exclamation-circle', false)"
                matTooltip={{tooltipWorkshop}}
                matTooltipPosition="above"
               
              ></i></p>
              <mat-form-field appearance="outline">
                <mat-label>{{"Select" |translate}}</mat-label>

                <mat-select
                  formControlName="taller"
                >
                  <mat-option
                    *ngFor="let workshop of workshops"
                    [value]="workshop.workshopId"
                    (click)="onWorkshopChange(workshop.workshopId)"
                  >
                    {{ workshop.workshopName }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  tallerControl?.invalid &&
                  (tallerControl?.touched || tallerControl?.dirty)
                "
              >
                <p class="error-ms">{{"ObligatoryField" |translate}}</p>
              </div>
            </div>
            <div class="form-input-select">
              <p>{{"Advisor" |translate}}</p>
              <mat-form-field appearance="outline">
                <mat-label>{{"Select" |translate}}</mat-label>

                <mat-select
                  formControlName="asesor"
                  
                >
                  <mat-option
                    
                    *ngFor="let advisor of advisors"
                    [value]="advisor.advisorId"
                    (click)="onAdvisorChange(advisor.advisorId)"
                  >
                    {{advisor.advisorName}}
                  </mat-option>
                </mat-select>
              </mat-form-field>
              <div
                *ngIf="
                  asesorControl?.invalid &&
                  (asesorControl?.touched || asesorControl?.dirty)
                "
              >
                <p class="error-ms">{{"ObligatoryField" |translate}}</p>
              </div>
            </div>
            <div class="form-input-area">
              <mat-form-field class="example-full-width" appearance="outline">
                <mat-label>{{"Observations" |translate}}</mat-label>
                <textarea
                matInput
                formControlName="observations"
                maxlength="4000"
                placeholder= {{PlaceHolderObservations}}
                ></textarea>
              </mat-form-field>
            </div>
           
          </div>
          <div class="check-form" *ngIf="TermAndConditiosMode === 'Derco'">
            <div class="text-check">                                       
              Observaciones:
              <li>Si no ubica en la lista su taller favorito o de la ciudad donde se encuentra, comuníquese a nuestra central telefónica 017135050.</li>
              <li>Debido a las dimensiones de los siguientes vehículos, estos solo pueden ser atendidos en el local de Dercocenter SURCO: JAC X200, JAC Sunray, Citroen Jumper, Changan Q20, Renault Master.</li>
              <li>Para mantenimientos preventivos de sistema de gas agendarse exclusivamente en los talleres deDerco Center Surco y Derco Center Ate</li>
              <li>Para mantenimientos correctivos de sistema de gas agendarse exclusivamente en el taller de Derco Center Ate</li>
              <li>La tolerancia será de 10 minutos. Posterior a este rango, la atención podría ser reprogramada.</li>
              <li>Deberá traer SOAT vigente, tarjeta de propiedad, llave de capó, permiso de lunas y revisión técnica, si fuese el caso.</li>
              <li>Es necesario retirar del vehículo TODOS sus objetos o pertenencias antes de acercarse al taller.</li>
              <br> 
              <strong><u>Observaciones específicas por tipo de trabajo:</u></strong>
              <li><strong>Mantenimiento preventivo:</strong> Servicios preventivos requeridos por el fabricante a partir de 5mil o 10mil kms en adelante, según la marca del vehículo.</li>
              <li><strong>Mantenimiento correctivo:</strong> Dercocenter Chorrillos no realiza trabajos de alineamiento, reparación demotor, caja de transmisión ni aire acondicionado</li>
              <li><strong>Activación de sistema GLP:</strong> Servicio disponible SOLO para activación de sistema GLP. La unidad debe ingresar al taller con una recarga mínima de S/.20 soles en el tanque de gas. Si su vehículo tiene sistema GNV, debe reservar su cita en el local de Derco ATE.</li>
              <li><strong>Activación de sistema GNV:</strong>Servicio disponible SOLO en el local de Derco ATE. La activación de sistema GNV solo se puede realizar de Lunes a Viernes (no sábados).</li>
              <br> 
            </div>
          </div>
          <div class="container-btn-reservation">
            <button mat-stroked-button class="btn-reservation" (click)="backInitialChoose()">{{"Back" |translate}}</button>

            <button
              mat-raised-button
              class="btn-reservation-sig"
              type="button"
              matStepperNext
              [disabled]="nextDisabled()"
            >
            {{"Next" |translate}}
            </button>
          </div>
        </form>
      </mat-step>
      <!-- <mat-step class="item-step-service step-2" [stepControl]="formValidation2" label="Completa tus datos" > -->
      <mat-step [stepControl]="firstFormGroup" >
        <form [formGroup]="formValidation2">
          <ng-template matStepLabel>{{CompleteData |translate}}</ng-template>
          <section class="section-complete-reserv">
            <div class="content-complete-reserv">
              <div class="container-fomr" [formGroup]="formValidation2">
                <h3 
                  class="input-title-blue" 
                  *ngIf="TermAndConditiosMode === 'Derco'" 
                >
                {{"CustomerAndVehicleData" |translate}}
                </h3>
                <h3 
                  class="input-title-blue" 
                  *ngIf="TermAndConditiosMode !=='Derco'"
                >
                  {{"PlateVehicle" |translate}}
                </h3>
                <div class="content-data">
                <div class="form-input" *ngIf=" isNewSchedule()">
                  <p *ngIf="isNewSchedule() && TermAndConditiosMode === 'Derco'">{{"IdDerco" |translate}}</p>
                  <p *ngIf="isNewSchedule() && recievedCountryData === 3">{{"Rut" |translate}}</p>
                  <p *ngIf="isNewSchedule() && recievedCountryData !== 3 &&TermAndConditiosMode !=='Derco'" >{{"Identification" |translate}}</p>
                  <mat-form-field appearance="outline" *ngIf="isNewSchedule()">
                    <input matInput formControlName="cedula"
                      maxlength="20"/>
                  </mat-form-field>
                  <div
                  *ngIf="recievedCountryData === 3"
                >
                  <p
                    class="mensagePatentModel"
                   
                  >
                  {{"Example"|translate}}: 1111111-1
                  </p>
                </div>
                
                  <div
                    *ngIf="
                      cedulaControl?.invalid &&
                      (cedulaControl?.touched || cedulaControl?.dirty)
                    "
                  >
                    <p
                      class="error-ms"
                      *ngIf="cedulaControl.errors?.['required']"
                    >
                      {{"ObligatoryField" |translate}}
                    </p>
                    <p
                      class="error-ms"
                      *ngIf="cedulaControl.errors?.['pattern']"
                    >
                      {{"ObligatoryNumbers" |translate}}
                    </p>
                    <p
                      class="error-ms"
                      *ngIf="cedulaControl.errors?.['minlength']"
                    >
                      {{"MinimumCharacters" |translate}}
                    </p>
                  </div>
                </div>
                <div class="form-input-plate">
                  <p *ngIf="recievedCountryData === 3">{{"Patent" |translate}}</p>
                  <p *ngIf="recievedCountryData !== 3">{{"Plate"|translate}}</p>
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      formControlName="placa"
                      (change)="transformInput($event)"
                    />
                  </mat-form-field>
                  <button
                    mat-raised-button
                    class="btn-icon"
                    *ngIf="isNewSchedule()"
                    (click)="onPlateNumberSearchClick()"
                  >
                    <!-- <i  *ngIf="recievedCountryData !== 3" class="bi bi-search"></i> -->
                    <i class="bi bi-search" >&nbsp;&nbsp;{{"Search"|translate}}</i>
                  </button>
                  <div
                  *ngIf="recievedCountryData === 3"
                >
                  <p
                    class="mensagePatentModel"
                   
                  >
                 {{"Example"|translate}}: AABB12
                  </p>
                </div>
                <div
                  *ngIf="TermAndConditiosMode === 'Derco'"
                >
                  <p
                    class="mensagePatentModel"
                  >
                    {{"Example"|translate}}: XYZ123
                  </p>
                </div>
                  <div
                    *ngIf="
                      placaControl?.invalid &&
                      (placaControl?.touched || placaControl?.dirty)
                    "
                  >
                    <p
                      class="error-ms"
                      *ngIf="placaControl.errors?.['required']"
                    >
                      {{"ObligatoryField" |translate}}
                    </p>
                  </div>
                </div>
              </div>
                <br>
                <br>
                <div class="Spinner" *ngIf="loadingSerchPlate"><mat-spinner></mat-spinner></div>
                <div class="fill-details" *ngIf="details === isNewSchedule()">
                  <h3 *ngIf="edited === true" class="input-title-blue">
                    {{"VerifyDataOwner" |translate}}
                  </h3>
                  <h3 *ngIf="edited2 === false" class="input-title-blue">
                    {{"CompleteDataOwner" |translate}}
                  </h3>
                  <div class="grid-container-service">
                    <div class="form-input-select">
                      <div class="item-form">
                        <div>
                          <p>{{"DocumentType" |translate}}</p>
                          <mat-form-field appearance="outline">
                            <mat-select formControlName="tip_Doc" >
                              <mat-option
                                *ngFor="let typeofdocument of documentType"
                                [value]="typeofdocument.typeId"
                                
                              >
                                {{ typeofdocument.typeName }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>

                          <div
                            *ngIf="
                              tip_DocControl?.invalid &&
                              (tip_DocControl?.touched || tip_DocControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="tip_DocControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p>{{"NumerDocument" |translate}}</p>
                          <mat-form-field appearance="outline">
                            <input matInput formControlName="cedula" />
                          </mat-form-field>

                          <div
                            *ngIf="
                              cedulaControl?.invalid &&
                              (cedulaControl?.touched || cedulaControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['pattern']"
                            >
                              {{"ObligatoryNumbers" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="cedulaControl.errors?.['minlength']"
                            >
                              {{"MinimumCharacters" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input">
                      <div class="item-form-input">
                        <div>
                          <p>{{"FirstName" |translate}}</p>

                          <mat-form-field appearance="outline">
                            <input matInput formControlName="nombres" />
                          </mat-form-field>
                          <div
                            *ngIf="
                              nombresControl?.invalid &&
                              (nombresControl?.touched || nombresControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="nombresControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>

                        <div>
                          <p>{{"LastName" |translate}}</p>
                          <mat-form-field appearance="outline">
                            <input matInput formControlName="apellidos" />
                          </mat-form-field>
                          <div
                            *ngIf="
                              apellidosControl?.invalid &&
                              (apellidosControl?.touched ||
                                apellidosControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="apellidosControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input-select">
                      <div class="item-form">
                        <!-- <div>
                          <p>{{"CodCountry" |translate}}</p>
                          <mat-form-field appearance="outline">
                            <mat-label>{{"Select" |translate}}</mat-label>

                            <mat-select formControlName="cod_pais">
                              <mat-option
                                *ngFor="let code of codes"
                                [value]="code"
                              >
                                {{ code }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                          <div
                            *ngIf="
                              cod_paisControl?.invalid &&
                              (cod_paisControl?.touched ||
                                cod_paisControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="cod_paisControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div> -->

                        <div>
                          <p>{{"Phone" |translate}}</p>
                          <mat-form-field appearance="outline">
                            <mat-label>{{"Phone" |translate}}</mat-label>

                            <input matInput formControlName="celular" />
                          </mat-form-field>
                          <div
                            *ngIf="
                              celControl?.invalid &&
                              (celControl?.touched || celControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['pattern']"
                            >
                              {{"ObligatoryNumbers" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="celControl.errors?.['minlength']"
                            >
                              {{"MinimumCharacters" |translate}}
                            </p>
                          </div>
                        </div>
                        <div>
                          <p>{{"Email" |translate}}</p>
                          <mat-form-field appearance="outline">
                            <input matInput formControlName="correo" />
                          </mat-form-field>
                          <div
                            *ngIf="
                              correoControl?.invalid &&
                              (correoControl?.touched || correoControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="correoControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                            <p
                              class="error-ms"
                              *ngIf="correoControl.errors?.['email']"
                            >
                            {{"Invalidemail" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div class="form-input">
                      <div class="item-form-input">
                        
                        <div *ngIf="!isNewUser">
                          <p>VIN</p>
                          <mat-form-field appearance="outline">
                            <input matInput formControlName="vin" />
                          </mat-form-field>
                          <div
                            *ngIf="
                              vinControl?.invalid &&
                              (vinControl?.touched || vinControl?.dirty)
                            "
                          >
                            <p
                              class="error-ms"
                              *ngIf="vinControl.errors?.['required']"
                            >
                              {{"ObligatoryField" |translate}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="info-owner">
                  <div class="container-raddio" >
                    <h3>{{"OwnerWillBeOnSite" |translate}}</h3>
                    <div class="custom-radio">
                      <input
                        #isOwnerRadio
                        name="isOwnerOnSite"
                        formControlName="isOwnerOnSite"
                        value="true"
                        type="radio"
                        [(ngModel)] = "selectOwnerOnSite"
                        id="custom-radio1"
                        (change)="toBoolean($event)"
                      />
                      <label for="custom-radio1">{{"Yes" |translate}}</label>
                    </div>
                    <div class="custom-radio">
                      <input
                        name="isOwnerOnSite"
                        formControlName="isOwnerOnSite"
                        type="radio"
                        id="custom-radio2"
                        value="false"
                        [(ngModel)] ="selectOwnerOnSite"
                        (change)="toBoolean($event)"
                      />
                      <label for="custom-radio2">No</label>
                    </div>
                  </div>
                  <!--AQUI TERMINA EL FORMULARIO COMPLETE DATOS DEL PROPIETARIO-->
                  <div
                    class="section-representante"
                    *ngIf="isOwnerOnSite === false"
                    [formGroup]="formValidation_representative"
                  >
                    <h3 class="input-title-blue">{{"RepresentativeData" |translate}}</h3>
                    <div class="grid-container-service">
                      <div class="form-input-select">
                        <div class="item-form">
                          <div>
                            <p>{{"DocumentType" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <mat-label>{{"Select" |translate}}</mat-label>

                              <mat-select
                                formControlName="representativeDocumentType"
                              >
                                <mat-option
                                *ngFor="let typeofdocument of this.documentType"
                                [value]="typeofdocument.typeId"
                              >
                                {{ typeofdocument.typeName }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeDocumentTypeControl?.invalid &&
                                (representativeDocumentTypeControl?.touched ||
                                  representativeDocumentTypeControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentTypeControl.errors?.['required']"
                              >
                                El campo es Obligatorio
                              </p>
                            </div>
                          </div>

                          <div>
                            <p>{{"NumerDocument" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                formControlName="representativeDocumentNumber"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeDocumentNumberControl?.invalid &&
                                (representativeDocumentNumberControl?.touched ||
                                  representativeDocumentNumberControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['pattern']"
                              >
                                {{"ObligatoryNumbers" |translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativeDocumentNumberControl.errors?.['minlength']"
                              >
                                {{"MinimumCharacters" |translate}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-input">
                        <div class="item-form-input">
                          <div>
                            <p>{{"FirstName" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                formControlName="representativeName"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeNameControl?.invalid &&
                                (representativeNameControl?.touched ||
                                  representativeNameControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeNameControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                            </div>
                          </div>

                          <div>
                            <p>{{"LastName" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <!-- [(ngModel)]="ownerLastName" -->
                              <input
                                matInput
                                formControlName="representativeLastName"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeLastNameControl?.invalid &&
                                (representativeLastNameControl?.touched ||
                                  representativeLastNameControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeLastNameControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="form-input-select">
                        <div class="item-form">
                          <!-- <div>
                            <p>{{"CodCountry" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <mat-select
                                formControlName="representativeCountryCode"

                              >
                                <mat-option
                                  *ngFor="let codeRep of codesRep"
                                  [value]="codeRep"
                                  
                                >
                                  {{ codeRep }}
                                </mat-option>
                              </mat-select>
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeCountryCodeControl?.invalid &&
                                (representativeCountryCodeControl?.touched ||
                                  representativeCountryCodeControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeCountryCodeControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                            </div>
                          </div> -->

                          <div>
                            <p>{{"Phone" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                formControlName="representativePhone"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativePhoneControl.invalid &&
                                (representativePhoneControl.touched ||
                                  representativePhoneControl.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativePhoneControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativePhoneControl.errors?.['pattern']"
                              >
                                {{"ObligatoryNumbers" |translate}}
                              </p>
                            </div>
                          </div>

                          <div>
                            <p>{{"Email" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <input matInput formControlName="representativecorreo" />
                            </mat-form-field>
                            <div
                              *ngIf="
                              representativecorreoControl?.invalid &&
                                (representativecorreoControl?.touched || representativecorreoControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativecorreoControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                              <p
                                class="error-ms"
                                *ngIf="representativecorreoControl.errors?.['email']"
                              >
                              {{"Invalidemail" |translate}}
                              </p>
                            </div>
                          </div>



                        </div>
                      </div>

                      <div class="form-input">
                        <div class="item-form-input">
                          
                          <div>
                            <p>{{"RelationOwner" |translate}}</p>
                            <mat-form-field appearance="outline">
                              <input
                                matInput
                                formControlName="representativeRelationWithOwner"
                              />
                            </mat-form-field>
                            <div
                              *ngIf="
                                representativeRelationWithOwnerControl?.invalid &&
                                (representativeRelationWithOwnerControl?.touched ||
                                  representativeRelationWithOwnerControl?.dirty)
                              "
                            >
                              <p
                                class="error-ms"
                                *ngIf="representativeRelationWithOwnerControl.errors?.['required']"
                              >
                                {{"ObligatoryField" |translate}}
                              </p>
                            </div>
                          </div>
                        </div>
                      </div>

                     
                    </div>
                  </div>

                  <div class="check-form representante" *ngIf="isOwnerOnSite === false">
                    <mat-checkbox
                      class="check"
                      [color]="task.color"
                      formControlName="canTakeDecision"
                    ></mat-checkbox>
                    <div class="text-check">
                      {{"Representative" | translate}}
                    </div>
                  </div>

                  <!-- Chile Form recomendations -->
                  <div class="check-form" *ngIf="TermAndConditiosMode === 'Chile'">
                    <div class="text-check">                                       
                      Recomendaciones:
                      <li>Llegar 5 minutos antes de la hora acordada. (Tiempo máximo de espera 15 minutos)</li>
                      <li>Retirar todos los objetos personales del vehículo, no podremos responsabilizarnos por éstos. (Facilita el lavado de cortesía y no existe custodia en sucursal)</li>
                      <li>El vehículo debe tener autonomía de combustible de al menos 100 km.</li>
                      <br> 
                    </div>
                  </div>

                  <!-- Peru Form recomendations -->
                  <div class="check-form" *ngIf="TermAndConditiosMode === 'Peru'">
                    <div class="text-check">                                       
                      Recomendaciones:
                      <li>Llegar 10 minutos antes de la hora acordada. (Tiempo máximo de espera 15 minutos)</li>
                      <li>Retirar todos los objetos personales del vehículo, no podremos responsabilizarnos por éstos.</li>
                      <li>Traer el SOAT vigente y tarjeta de propiedad.</li>
                      <br> 
                    </div>
                  </div>

                  <div class="check-form" *ngIf="TermAndConditiosMode === 'Peru2'">
                    <div class="text-check">                                       
                      Observaciones:
                      <li>La tolerancia será de 10 minutos. Posterior a este rango, la atención podría ser reprogramada.</li>
                      <li>Deberá traer SOAT vigente, tarjeta de propiedad, llave de capó, permiso de lunas y revisión técnica, si fuese el caso.</li>
                      <li>Es necesario retirar del vehículo TODOS sus objetos o pertenencias, el Asesor de Servicio no podrá recibir la unidad si tuviese cosas en el interior.</li>
                      <li>No se reciben pagos en efectivo. Solo se aceptan transferencias, pago por POS o enlace seguro.</li>
                      <br> 
                    </div>
                  </div>


                  <div class="check-form" *ngIf="TermAndConditiosMode === 'Colombia'">
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <p>
                      <span style="font-size: 10px"
                        ><span style="font-family: Calibri, sans-serif"
                          ><span style="font-family: -apple-system"
                            >&nbsp;Declaro que he sido informado por el grupo
                            empresarial compuesto por las sociedades:
                            Inchcape Colombia S.A.S, Derco Colombia S.A.S, 
                            Derco Agencia de Seguros LTDA., Matrase S.A.S, 
                            Distribuidora Hino de Colombia
                            S.A.S e Inmobiliaria Inchcape de Colombia S.A.S.
                            En adelante Las
                            Compa&ntilde;&iacute;as, que ser&aacute;n el
                            Responsable del Tratamiento de sus Datos
                            Personales, por lo que autoriz&oacute; de manera
                            previa, libre, voluntaria, inequ&iacute;voca,
                            expresa e informada a Las
                            Compa&ntilde;&iacute;as o quien represente sus
                            derechos, tambi&eacute;n a la sociedad matriz
                            y/o subordinadas en Colombia o en el exterior, y
                            en especial, a cualquiera de las sociedades del
                            grupo INCHCAPE dentro de las que se encuentra
                            Inchcape DDC Colombia S.A.S, Bravoauto S.A.S e
                            incluyendo mas no limit&aacute;ndose a INCHCAPE
                            PLC, y en general a sus aliados
                            estrat&eacute;gicos y/o distribuidores
                            autorizados, fabricantes de veh&iacute;culos que
                            representan e importan y a los concesionarios de
                            la red de Las Compa&ntilde;&iacute;as en
                            Colombia a recolectar, almacenar, usar, circular
                            y suprimir sus datos personales, conforme a la
                            Pol&iacute;tica de Tratamiento de Datos
                            Personales descrita en el siguiente link
                            <a
                              href="http://www.pracodidacol.com"
                              style="
                                color: #0563c1;
                                text-decoration: underline;
                              "
                              target="_blank"
                              title="http://www.pracodidacol.com/"
                              >www.pracodidacol.com</a
                            >, y en cumplimento de la Ley Estatutaria 1581
                            de 2012, ley 1266 de 2008, ley 2300 de 2023  
                            y dem&aacute;s normas, modificatorias, aclaratorios, 
                            complementarias y/o derogatorias. Con la presente
                            autorizaci&oacute;n del tratamiento de sus datos
                            personales se le podr&aacute; contactar mediante
                            sms, whatsapp, correo electr&oacute;nico,
                            direcci&oacute;n de residencia, llamada
                            telef&oacute;nica y/o cualquier otro medio de
                            comunicaci&oacute;n instant&aacute;neo o formal
                            por motivos de:&nbsp; Env&iacute;o de
                            informaci&oacute;n relacionada con todo el
                            concepto de experiencia de cualquiera de las
                            marcas que hacen parte de Las
                            Compa&ntilde;&iacute;as, ya sea para fines de
                            actualizaci&oacute;n de datos, invitaci&oacute;n
                            a eventos, env&iacute;o de publicidad, fines
                            estad&iacute;sticos, env&iacute;o de
                            informaci&oacute;n de productos y servicios,
                            ofertas, descuentos, informaci&oacute;n
                            corporativa, auditorias, seguimientos,
                            promociones, encuestas, llamadas de seguimiento,
                            env&iacute;o de productos a la direcci&oacute;n
                            de residencia, as&iacute; como env&iacute;o de
                            informaci&oacute;n de campa&ntilde;as
                            t&eacute;cnicas de servicio, seguridad o
                            &ldquo;recall&rdquo;, de productos financieros y
                            de seguros para la adquisici&oacute;n de bienes
                            y servicios&nbsp; de cualquiera de las marcas
                            que hacen parte de Las Compa&ntilde;&iacute;as;
                            de igual forma, esta autorizaci&oacute;n
                            comprende el mandato expreso para que su
                            informaci&oacute;n haga parte de la Base de
                            Datos de cualquiera de las
                            Compa&ntilde;&iacute;as, as&iacute; como
                            tambi&eacute;n pueda ser transferida y/o
                            transmitida a otras compa&ntilde;&iacute;as
                            externas del grupo Inchcacape con residencia en Colombia o
                            en otros pa&iacute;ses, incluyendo mas no
                            limit&aacute;ndose a las marcas de los productos
                            que importa, comercializa y distribuyen las
                            Compa&ntilde;&iacute;as en Colombia. Como
                            titular de la informaci&oacute;n es consciente
                            que tiene el derecho a conocer, actualizar y
                            rectificar sus datos personales, solicitar 
                            prueba de la autorizaci&oacute;n otorgada para su trámite, 
                            revocar la autorizaci&oacute;n y/o solicitar la supresi&oacute;n 
                            de mis datos por medio de una
                            solicitud escrita dirigida a:
                            <a
                              href="mailto:didacol@didacol.com"
                              style="
                                color: #0563c1;
                                text-decoration: underline;
                              "
                              target="_blank"
                              title="mailto:didacol@didacol.com"
                              >didacol&#64;didacol.com</a
                            > y 
                            <a
                              href="mailto:didacol@didacol.com"
                              style="
                                color: #0563c1;
                                text-decoration: underline;
                              "
                              target="_blank"
                              title="mailto:didacol@didacol.com"
                              >servicioalcliente&#64;derco.com.co</a
                            >
                            .</span
                          ></span
                        ></span
                      >
                    </p>
                    <p>&nbsp;</p>
                  </div>

                  <div class="check-form"  *ngIf="TermAndConditiosMode === 'Colombia'">
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Declaro conocer y entender la
                      <span class="them-blue"
                        >política de protección de datos personales</span
                      >
                      y autorizo expresamente el tratamiento de mis datos
                      personales
                    </div>
                  </div>

                 <!-- Default Form term and conditions -->                                
                  <div class="check-form" *ngIf="TermAndConditiosMode !== 'Colombia' && TermAndConditiosMode !== 'Bélgica'&& TermAndConditiosMode !== 'Derco' ">
                    <mat-checkbox
                      formControlName="terms"
                      class="check"
                      [color]="task.color"
                    ></mat-checkbox>
                    <div class="text-check">
                      Acepto
                      <span class="them-blue">términos y condiciones</span>
                    </div>
                  </div>



                  <div class="check-form"  *ngIf="TermAndConditiosMode === 'Default'">
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Declaro conocer y entender la
                      <span class="them-blue"
                        >política de protección de datos personales</span
                      >
                      y autorizo expresamente el tratamiento de mis datos
                      personales
                    </div>
                  </div>

                   <!-- Chile Form term and conditions -->
                  

                  <div class="check-form"  *ngIf="TermAndConditiosMode === 'Chile'">
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Legales:
                      <li>BMW Service realizará un llamado telefónico de confirmación de cita el día anterior a la cita solicitada para recordar al cliente y confirmar asistencia.</li>
                      <li>En el caso de agendamiento vía Web eventualmente se hará una llamada telefónica para solicitar más información acerca de los servicios solicitados y reagendar una nueva cita de forma de entregar la atención más adecuada al requerimiento.</li>
                      <li>En caso de que el trabajo requiera repuestos u otros, el cliente podría ser contactado para reagendar una nueva cita, según la disponibilidad de los repuestos o implementos necesarios.</li>
                      <li>Vehículos con campaña técnica, falla mecánica o mantención a partir de 40.000 km podrían no ser entregados el mismo día de entrega, dependiendo de la complejidad del caso.</li>
                      <li>Mediante el presente autorizo a Williamson Balfour Motors Spa a tratar y/o compartir mi información con sociedades relacionadas y concesionarios autorizados de la marca, para recibir información relevante y/o encuestas, entre otros. Declaro que he sido informado  acerca del propósito del almacenamiento de mis datos personales contenidos en el presente instrumento y autorizo el tratamiento de conformidad que regula la ley 19.628 de protección de datos de carácter personal.</li>                     
                    </div>
                  </div>

                   <!-- Peru Form term and conditions -->
                  

                   <div class="check-form"  *ngIf="TermAndConditiosMode === 'Peru'">
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Legales:
                      <li>En el caso de agendamiento vía Web eventualmente se hará una llamada telefónica para solicitar más información acerca de los servicios solicitados y reagendar una nueva cita de forma de entregar la atención más adecuada al requerimiento.</li>
                      <li>En caso de que el trabajo requiera repuestos u otros, el cliente podría ser contactado para reagendar una nueva cita, según la disponibilidad de los repuestos o implementos necesarios.</li>
                      <li>Declaro conocer y entender la <a href="https://www.inchcapemotors.pe/bmw/advertencia-legal">Política de Protección de Datos Personales</a>  y autorizo expresamente el tratamiento de mis datos personales. Acepto también la transferencia de mis datos personales a Inchcape PLC y BMW México SA de CV para fines promocionales, comerciales o publicitarios.</li>
                      <li>Vehículos con campaña técnica, falla mecánica o mantención a partir de 40.000 km podrían no ser entregados el mismo día de entrega, dependiendo de la complejidad del caso.</li>
                     </div>
                  </div>

                  <div class="check-form"  *ngIf="TermAndConditiosMode === 'Peru2'">
                    <mat-checkbox
                      formControlName="politics"
                      class="check"
                      [color]="task.color"
                      required
                    ></mat-checkbox>
                    <div class="text-check">
                      Legales:
                      <li>Los vehículos con campaña técnica, falla mecánica o mantenimiento a partir de 45.000 km podrían no ser entregados el mismo día, dependiendo de la complejidad del caso.</li>
                      <li>Declaro conocer y entender la Política de Protección de Datos Personales y autorizo expresamente el tratamiento de mis datos personales. Acepto también la transferencia de mis datos personales para fines promocionales, comerciales o publicitarios.</li>
                     </div>
                  </div>
                 <!-- Belgica Form term and conditions -->
                 <div class="check-form"  *ngIf="TermAndConditiosMode === 'Bélgica'">
                  <mat-checkbox
                  formControlName="terms"
                  class="check"
                  [color]="task.color"
                  ></mat-checkbox>
                  <div class="text-check">
                    {{"TermAndConditionsBelgica1"|translate}}
                   
                    <a  href='{{UrlTermAndConditionBelgica}}'> {{"TermAndConditionsBelgica2"|translate}}</a>
                                    
                  </div>
                </div>

                 <div class="check-form"  *ngIf="TermAndConditiosMode === 'Bélgica'">
                  <mat-checkbox
                    formControlName="politics"
                    class="check"
                    [color]="task.color"
                    required
                  ></mat-checkbox>
                  <div class="text-check">
                  
                    <a   href='{{UrlTermAndConditionBelgica}}'> {{"politicsBelgica1"|translate}}</a> 
                    {{"politicsBelgica2"|translate}}
                                      
                  </div>
                </div>
                
                <div class="check-form" *ngIf="TermAndConditiosMode === 'Derco'">
                  <mat-checkbox
                    formControlName="terms"
                    class="check"
                    [color]="task.color"
                  ></mat-checkbox>
                  <div class="text-check">
                    Acepto
                    <a  href='https://www.derco.com.pe/terminos-y-condiciones'>términos y condiciones</a>
                  </div>
                </div>

                <div class="check-form"  *ngIf="TermAndConditiosMode === 'Derco'">
                  <mat-checkbox
                    formControlName="politics"
                    class="check"
                    [color]="task.color"
                    required
                  ></mat-checkbox>
                  <div class="text-check">
                    Legales:
                    <li>Los vehículos con campaña técnica, falla mecánica o mantenimiento a partir de 45.000 km podrían no ser entregados el mismo día, dependiendo de la complejidad del caso.</li>
                    <li>Declaro conocer y entender la Política de Protección de Datos Personales y autorizo expresamente el tratamiento de mis datos personales. Acepto también la transferencia de mis datos personales para fines promocionales, comerciales o publicitarios.</li>
                    </div>
                </div>

               
                 



                  <div class="container-btn-reservation">
                    <button
                      mat-stroked-button
                      class="btn-reservation"
                      matStepperPrevious
                    >
                     {{"Back"|translate}}
                    </button>

                    <button
                      mat-raised-button
                      class="btn-reservation-sig"
                      type="button"
                      matStepperNext
                      [disabled]="formsValidations()"
                      (click)="NameDocument()"
                    >
                    {{"Next"|translate}}
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </section>
        </form>
      </mat-step>
      <!-- <mat-step [stepControl]="formValidation" label="{{FinalizeReservationr |translate}}:"> -->
      <mat-step [stepControl]="firstFormGroup">
        <ng-template matStepLabel>{{FinalizeReservationr |translate}}</ng-template>
        <form class="section-finalize-reservation">
          <div class="content-finalize-reservation">
            <h3 class="input-title-blue">{{"VerifyYourDetails"|translate}}:</h3>
            <div class="container-form-finalize">
              <div class="item-form-finalize">
                <p>{{"DocumentType" |translate}}</p>
                <h3>{{ nameDocumentType.typeName }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>{{"NumerDocument" |translate}}</p>
                <h3>{{ formValidation2.controls.cedula.value }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>{{"FirstName" |translate}}</p>
                <h3>{{ formValidation2.controls.nombres.value }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>{{"LastName" |translate}}</p>
                <h3>{{ formValidation2.controls.apellidos.value }}</h3>
              </div>

              <!-- <div class="item-form-finalize">
                <p>{{"CodCountry" |translate}}</p>
                <h3>{{ this.formValidation2.value.cod_pais }}</h3>
              </div> -->
              <div class="item-form-finalize">
                <p>{{"Phone" |translate}}</p>
                <h3>{{ formValidation2.controls.celular.value }}</h3>
              </div>
              <div class="item-form-finalize">
                <p>{{"Email" |translate}}</p>
                <h3>{{ formValidation2.controls.correo.value }}</h3>
              </div>
              <div class="item-form-finalize" *ngIf="!isNewUser">
                <p>VIN</p>
                <h3>{{ formValidation2.controls.vin.value }}</h3>
              </div>
            </div>
            <div class="container-btn-reservation">
              <button
                mat-stroked-button
                class="btn-reservation"
                matStepperPrevious
              >
              {{"Back"|translate}}
              </button>

              <button
                mat-raised-button
                class="btn-finalize-reservation"
                type="submit"
                (click)="onSave()"
              >
                {{"FinalizeReservation" |translate}}
              </button>
            </div>
          </div>
        </form>
      </mat-step>
    </mat-stepper>
  </div>
</section>
